/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Edit_Event_Group_Error_Detection_HeadingInputs */

const en_edit_event_group_error_detection_heading = /** @type {(inputs: Edit_Event_Group_Error_Detection_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error Detection`)
};

const fr_edit_event_group_error_detection_heading = /** @type {(inputs: Edit_Event_Group_Error_Detection_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Détection d'erreurs`)
};

const de_edit_event_group_error_detection_heading = /** @type {(inputs: Edit_Event_Group_Error_Detection_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fehlererkennung`)
};

const it_edit_event_group_error_detection_heading = /** @type {(inputs: Edit_Event_Group_Error_Detection_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rilevamento degli errori`)
};

const ru_edit_event_group_error_detection_heading = /** @type {(inputs: Edit_Event_Group_Error_Detection_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обнаружение ошибок`)
};

const es_edit_event_group_error_detection_heading = /** @type {(inputs: Edit_Event_Group_Error_Detection_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detección de errores`)
};

const zh_cn2_edit_event_group_error_detection_heading = /** @type {(inputs: Edit_Event_Group_Error_Detection_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`错误检测`)
};

const ja_edit_event_group_error_detection_heading = /** @type {(inputs: Edit_Event_Group_Error_Detection_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`エラー検出`)
};

const hi_edit_event_group_error_detection_heading = /** @type {(inputs: Edit_Event_Group_Error_Detection_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`त्रुटि का पता लगाना`)
};

const pt_pt2_edit_event_group_error_detection_heading = /** @type {(inputs: Edit_Event_Group_Error_Detection_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detecção de erro`)
};

/**
* | output |
* | --- |
* | "Error Detection" |
*
* @param {Edit_Event_Group_Error_Detection_HeadingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const edit_event_group_error_detection_heading = /** @type {((inputs?: Edit_Event_Group_Error_Detection_HeadingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Edit_Event_Group_Error_Detection_HeadingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_edit_event_group_error_detection_heading(inputs)
	if (locale === "de") return de_edit_event_group_error_detection_heading(inputs)
	if (locale === "it") return it_edit_event_group_error_detection_heading(inputs)
	if (locale === "ru") return ru_edit_event_group_error_detection_heading(inputs)
	if (locale === "es") return es_edit_event_group_error_detection_heading(inputs)
	if (locale === "zh-CN") return zh_cn2_edit_event_group_error_detection_heading(inputs)
	if (locale === "ja") return ja_edit_event_group_error_detection_heading(inputs)
	if (locale === "hi") return hi_edit_event_group_error_detection_heading(inputs)
	if (locale === "pt-PT") return pt_pt2_edit_event_group_error_detection_heading(inputs)
	return en_edit_event_group_error_detection_heading(inputs)
});